<h5>Receipt incomplete rules</h5>
<div [formGroup]="grp" class="flex-column gap-8">

  <!-- <mat-slide-toggle formControlName="hasOneLineItem" color="primary" (change)="onRuleChange()">
    <label class="form-label">Receipt must have at least one line item</label>
  </mat-slide-toggle> -->

  <mat-slide-toggle formControlName="requiredReceiptDate" color="primary" (change)="onRuleChange()">
    <label class="form-label">Receipt date is required</label>
  </mat-slide-toggle>

  <mat-slide-toggle formControlName="requiredInvoiceNo" color="primary" (change)="onRuleChange()">
    <label class="form-label">Invoice number is required</label>
  </mat-slide-toggle>

  <mat-slide-toggle formControlName="requiredVendorName" color="primary" (change)="onRuleChange()">
    <label class="form-label">Vendor Name is required</label>
  </mat-slide-toggle>

  <mat-slide-toggle formControlName="requiredVendorRawName" color="primary" (change)="onRuleChange()">
    <label class="form-label">Vendor RawName is required</label>
  </mat-slide-toggle>


</div>